import {
  ADMIN_ADVISORS_RECEIVED,
  ADMIN_ADVISORS_UNLOADED
} from './types'

export default function advisors(state = [], action = {}){
  switch (action.type) {
    case ADMIN_ADVISORS_RECEIVED:
      return action.advisors
    case ADMIN_ADVISORS_UNLOADED:
      return []
    default:
      return state;
  }
}